import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { DocumentsColumns, titleColumn, selectColumn, downloadColumn, postedColumn, letterNumberColumn, Category, statusColumn } from '../documents';
import { GroupingOptionItem } from '../grouping-selector';
import { includes } from 'lodash';

@Injectable()
export class GeneralDocumentsColumns implements DocumentsColumns {
    private columnsDictionary: { [key: string]: ColDef[] };

    constructor() {
        this.columnsDictionary = this.buildColumnsDictionary();
    }

    public getColumnDefinitions(category: Category | undefined): ColDef[] {
        if (!category) {
            return [];
        }

        const columns = this.columnsDictionary[category.categoryId] || [];
        return columns;
    }

    public hasStatusColumn(category: string) {
        return includes(this.columnsDictionary[category], statusColumn);
    }

    public getGroupedColumns(category: string): GroupingOptionItem[] {
        return [];
    }

    private buildColumnsDictionary() {
        const generalManualsColumns = [
            selectColumn,
            titleColumn,
            postedColumn,
            downloadColumn
        ];

        const generalCommunicationColumns = [
            selectColumn,
            titleColumn,
            letterNumberColumn,
            postedColumn,
            downloadColumn
        ];

        const generalTrainingMaterialsColumns = [
            selectColumn,
            titleColumn,
            postedColumn,
            downloadColumn
        ];

        const applicationTrainingColumns = [
            selectColumn,
            titleColumn,
            postedColumn,
            downloadColumn
        ];

        return {
            // general-manuals:
            'regulatory-documents': generalManualsColumns,
            'general-information': generalManualsColumns,
            'quick-reference-guide': generalManualsColumns,

            // general-communications
            'general-communications': generalCommunicationColumns,

            // general-training-materials:
            'specimen-collection': generalTrainingMaterialsColumns,
            'packaging-and-shipping': generalTrainingMaterialsColumns,

            // application-training:
            'application-training': applicationTrainingColumns,
        };
    }
}
